// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2PaymentTypeModels {
    static getAttributeTypeMap() {
        return EnrollmentV2PaymentTypeModels.attributeTypeMap;
    }
}
EnrollmentV2PaymentTypeModels.discriminator = undefined;
EnrollmentV2PaymentTypeModels.additionalProperties = false;
EnrollmentV2PaymentTypeModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<EnrollmentV2PaymentTypeModel>"
    },
];
//# sourceMappingURL=enrollmentV2PaymentTypeModels.js.map